import React, { Component } from 'react';
import { Table, Tooltip, ConfigProvider } from 'antd';
import './SharedTable.scss';
import { USER_SIGN_IN_SUCCESS } from 'Store/constants';
import { store } from 'Store/store.index';
import SharedUserList from './SharedUserList';
import SharedTableAction from './SharedTableAction';
import SharedBulkOperation from './SharedBulkOperation';
import intl from 'react-intl-universal';
import moment from 'moment';
import empty from './images/empty.png';
// import { UTCTimeFormat } from 'Utils/date';
// import { isPhantomOnline } from '@/utils/utils';
import { toJS } from 'mobx';
// import pdf_document from '@/assets/share/pdf_document.svg'
// import { isJPDomain } from '@/utils/utils';
// import ShareEmpty from './ShareEmpty';
import NetError from './NetError';
import { isSharedClound } from '@/api/index';

import { inject, observer } from 'mobx-react';
import { COLLABORATION_OPEN_START } from '@/constants/app.constant';
import { isFromReader } from '@/utils/collaboration-platform-reader';
@inject('appStore')
@observer
class SharedTable extends Component {
  constructor(props) {
    super(props);
    this.preventOpenFile = false;
    this.state = {
      shareList: [],
      selectList: [],
      openFileData: {},
      indeterminate: false,
      checkAll: false,
      queryData: {
        source: this.props.type === 'yours' ? 0 : 1,
        sort: 'createTime desc',
        perPage: 10,
        currentPage: 1,
        docName: this.props.searchWord ? this.props.searchWord : '',
      },
      loading: true,
    };
  }
  columns = [
    {
      title: intl.get('collaboration.sharedList.SharedTable.tableHeaderTitle.Name'),
      dataIndex: 'name',
      width: '470px',
      ellipsis: true,
      render: (text, record) => {
        return (
          <div
            className="nameBox"
            role="button"
            aria-label={text}
            onClick={(e) => {
              if (isSharedClound()) return;
              e.stopPropagation();
              this.setState(
                {
                  openFileData: record,
                },
                () => {
                  this.openFileBefore();
                },
              );
            }}>
            <Tooltip className="textBox" title={text}>
              <i className="pdfIcon"></i>
              <span>{text}</span>
            </Tooltip>
          </div>
        );
      },
    },

    {
      title: intl.get('collaboration.sharedList.SharedTable.tableHeaderTitle.People'),
      dataIndex: 'people',
      render: (text, record) => {
        return (
          <SharedUserList
            parentCom="SharedTable"
            peopleList={text}
            reviewSessionID={record.reviewSessionID}
            cDocID={record.docId}
            fileLink={record.fileLink}
            type={this.props.type}
            shareState={record.shareState}
            outerInviteParticipant={this.getShareReviewInviteParticipant}
          />
        );
      },
    },
    {
      title: intl.get('collaboration.sharedList.SharedTable.tableHeaderTitle.Status'),
      dataIndex: 'status',
    },
    {
      title: intl.get('collaboration.sharedList.SharedTable.tableHeaderTitle.LastActivity'),
      dataIndex: 'lastActivity',
    },
    {
      title: '操作',
      dataIndex: '',
      width: '80px',
      render: (text, record) => {
        return (
          <SharedTableAction
            parentCom="SharedTable"
            docProhibitComment={record.docProhibitComment}
            getShareReviewList={this.getShareReviewList}
            data={record}
            type={this.props.type}
            updateTableList={this.initList}
            reviewSessionID={record.reviewSessionID}
            cDocID={record.docId}
            fileLink={record.fileLink}
            docName={record.name}
          />
        );
      },
    },
  ];
  getShareReviewInviteParticipant = (reviewSessionID, callback) => {
    let { shareList } = this.state;
    store.collaborationStore.getShareReviewInviteParticipant(reviewSessionID).then(
      (res) => {
        const { ret, data } = res;
        const { list } = data;
        if (ret === 0) {
          let guestTxt = intl.get('collaboration.sharedList.guest');
          let unsharedTxt = intl.get('collaboration.sharedList.unsharedStatus');

          shareList.forEach((sItem) => {
            if (sItem.reviewSessionID == reviewSessionID) {
              sItem.memberList = list;
              const status = intl.get('collaboration.sharedList.commentStatus', { commentCount: sItem.commentAmount, memberCount: sItem.memberList.length });
              sItem.status = sItem.shareState ? unsharedTxt : status;
              sItem.people = list.map((item) => {
                const name = item.isGuest === 1 ? guestTxt : item.userName || 'unknown';
                return {
                  name,
                  ...item,
                };
              });
            }
          });
          this.setState({
            shareList: shareList,
          });
          callback && callback(list);
        }
      },
      (error) => {
        console.log(error);
      },
    );
  };
  componentDidMount() {
    this.props.setListFunc(this.initList);
    if (store.loginNewStore.isLogin) {
      setTimeout(() => {
        const parms = store.collaborationStore.shareReviewListParams;
        if (!!parms) {
          this.setState(
            {
              queryData: toJS(parms),
            },
            () => {
              this.getShareReviewList();
            },
          );
        } else {
          this.getShareReviewList();
        }
      }, 500);
    } else {
      store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, this.getShareReviewList);
    }
  }
  componentWillUnmount() {
    // store.collaborationStore.setShareListParams(null)
    store.appStore.removeAppEventListener(USER_SIGN_IN_SUCCESS, this.getShareReviewList);
  }

  onSelect = (selectedRowKeys) => {
    const { shareList } = this.state;
    this.setState({
      selectList: selectedRowKeys,
      indeterminate: !!selectedRowKeys.length && selectedRowKeys.length < shareList.map((item) => item.shareState === 0).length,
      checkAll: selectedRowKeys.length === shareList.map((item) => item.shareState === 0).length,
    });
  };
  onShowSizeChange = (current, pageSize) => {
    const sendData = { ...this.state.queryData };
    sendData.currentPage = 1;
    sendData.perPage = pageSize;
    this.setState({ queryData: { ...sendData } }, () => {
      this.getShareReviewList();
    });
  };
  pageChange = (page, pageSize) => {
    const sendData = { ...this.state.queryData };
    sendData.currentPage = page;
    sendData.perPage = pageSize;
    this.setState({ queryData: { ...sendData } }, () => {
      this.getShareReviewList();
    });
  };
  onCheckAllChange = (e) => {
    const { shareList } = this.state;
    this.setState({
      selectList: e.target.checked ? shareList.map((item) => item.shareState === 0).map((item) => item.id) : [],
      indeterminate: false,
      checkAll: e.target.checked,
    });
  };
  onChangeSetCurrentPage = () => {
    const { checkAll, queryData } = this.state;
    if (checkAll) {
      if (this.pagination.pageCount == queryData.currentPage && queryData.currentPage > 1) {
        queryData.currentPage = queryData.currentPage - 1;
        this.setState({ queryData: { ...queryData } });
      }
    }
  };
  pagination = {
    total: 0,
    // size: 'small',
    pageCount: 0,
    showSizeChanger: true,
    // showQuickJumper: true,
    // onShowSizeChange: this.onShowSizeChange,
    // hideOnSinglePage: true,
    onChange: this.pageChange,
    pageSizeOptions: ['10', '30', '50', '100'],
  };
  initList = (type) => {
    const { queryData, shareList } = this.state;
    if (type === 'init') {
      queryData.currentPage = 1;
    } else if (type === 'maintain') {
      if (shareList.length == 1 && queryData.currentPage > 1) {
        queryData.currentPage = this.pagination.pageCount - 1;
      }
    }
    this.setState({ queryData }, () => {
      this.getShareReviewList();
    });
  };
  getShareReviewList = () => {
    let { queryData } = this.state;
    queryData.docName = this.props.searchWord;
    this.setState({ queryData });
    store.collaborationStore.setShareListParams(this.state.queryData);
    this.setState({ loading: true });
    store.collaborationStore
      .getShareReviewList(this.state.queryData)
      .then((res) => {
        const { ret, data } = res;
        this.props.getShareList(data);
        if (ret === 0) {
          let unsharedTxt = intl.get('collaboration.sharedList.unsharedStatus');
          let guestTxt = intl.get('collaboration.sharedList.guest');

          const { totalCount, pageCount } = data;
          const list = data.list.map((item) => {
            let docProhibitComment = 0;
            const ownerUserId = item.cUserID;
            const status = intl.get('collaboration.sharedList.commentStatus', { commentCount: item.commentAmount, memberCount: item.memberList.length });
            const people = item.memberList.map((item) => {
              let name = guestTxt;

              if (item.cUserID === ownerUserId) {
                item.isOwner = 1;
                docProhibitComment = item.prohibitComment;
              }

              if (item.cUserID) name = item.userName || 'unknown';

              return {
                name,
                ...item,
              };
            });

            const keyIndex = item.lastActivityTime.lastIndexOf(':');

            item.lastActivityTime = item.lastActivityTime.slice(0, keyIndex);

            return {
              id: item._id,
              name: item.docName,
              sharedTime: item.createTime,
              img: item.docThumbnail,
              people: people,
              docProhibitComment,
              status: item.shareState ? unsharedTxt : status,
              lastActivity: moment(item.lastActivityTime).format('YYYY-MM-DD HH:mm:ss'),
              activeTotel: 1,
              nowActive: 1,
              activeList: [],
              ...item,
            };
          });

          this.pagination.total = totalCount;
          this.pagination.pageCount = pageCount;
          this.setState({
            shareList: list,
          });
        }
        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        console.error(error);
      });
  };
  openFileBefore = () => {
    if (!window.pdfui) {
      store.homePageStore.pdfUiInit(window._UIExtension, this.openFile);
      return false;
    } else {
      this.openFile();
    }
  };
  openFile = () => {
    const data = this.state.openFileData;
    store.collaborationStore.exitCollaboration(true);
    store.collaborationStore.setThisCDocId(data.docId);
    store.collaborationStore.resetCollaborationData();
    store.common.setIsShowMeeting(true);
    if (data && !data.fileLink) {
      store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.sharedList.Error.fileLinkEmpty') });
      return;
    }
    if (!this.preventOpenFile) {
      this.preventOpenFile = true;
      store.collaborationStore.setReviewSessionID(data.reviewSessionID);
      store.collaborationStore.setShareReviewData(data);
      // if(data.shareState === 1) return
      const sendData = {
        docId: data.docId,
        docName: data.docName,
        fileLink: data.fileLink,
        reviewSessionID: data.reviewSessionID,
      };

      const viewer = pdfui.pdfViewer;
      viewer.toggleCollaborationMode(true);

      if (data.shareState === 0) {
        store.appStore.viewerEventEmitter.emit('changeToolBar', 'collaboration');
      } else if (data.shareState === 1) {
        store.appStore.viewerEventEmitter.emit('changeToolBar', 'common');
      }

      store.appStore.sendPerformanceInfo({ event: COLLABORATION_OPEN_START, isEmit: false, lastEvent: true });
      store.collaborationStore.openSharedFile(sendData, 'sharedList');
      setTimeout(() => {
        this.preventOpenFile = false;
      }, 3000);
    }
  };
  getSeletcData = () => {
    const { shareList, selectList } = this.state;
    const list = [];
    selectList.forEach((item) => {
      shareList.forEach((sItem) => {
        if (sItem._id === item) list.push(sItem);
      });
    });
    return list;
  };
  initNowPage = () => {
    this.getShareReviewList();
    this.setState({
      selectList: [],
      indeterminate: false,
      checkAll: false,
    });
  };
  resetSelect = () => {
    this.setState({
      selectList: [],
      indeterminate: false,
      checkAll: false,
    });
  };
  setScroll = (shareList) => {
    const clientHeight = document.documentElement.clientHeight;
    if (shareList.length * 59 > clientHeight - 195 - 120) {
      return { y: 'calc(100vh - 195px - 130px)', scrollToFirstRowOnChange: true };
    } else {
      return {};
    }
  };
  renderEmpty = () => {
    const { loading } = this.state;
    return (
      !loading && (
        <div className="empty">
          <img src={empty} alt="" />
          没有分享的文档
        </div>
      )
    );
  };
  getContent = () => {
    // const { hasSignIn } = store.userStore;
    const { shareList, selectList, loading, queryData } = this.state;
    let { currentPage, perPage } = queryData;
    if (!!store.collaborationStore.shareReviewListParams && store.collaborationStore.shareReviewListParams.perPage) {
      perPage = store.collaborationStore.shareReviewListParams.perPage;
    }
    let rowSelection;
    if (isFromReader()) {
      rowSelection = null;
    } else {
      rowSelection = {
        type: 'checkbox',
        onChange: this.onSelect,
        selectedRowKeys: selectList,
        getCheckboxProps(value) {
          if (value.shareState === 1 && !isSharedClound()) {
            return {
              disabled: true,
            };
          }
        },
      };
    }
    const table = (
      <ConfigProvider renderEmpty={this.renderEmpty}>
        <Table
          rowSelection={rowSelection}
          scroll={this.setScroll(shareList)}
          loading={{ spinning: loading, tip: intl.formatMessage({ id: 'Loading.file' }) }}
          pagination={{ ...this.pagination, current: currentPage, defaultPageSize: perPage }}
          rowKey="id"
          columns={this.columns}
          dataSource={shareList}
        />
      </ConfigProvider>
    );
    // const shareEmpty = (
    //   <ShareEmpty
    //     supportConvertDocumentSuffixs={this.props.supportConvertDocumentSuffixs}
    //     isDisabledDragFileOpen={this.props.isDisabledDragFileOpen}
    //     onDrop={this.props.onDrop}
    //     openFile={this.props.openFile}
    //     canOpenFile={this.props.type === 'yours'}
    //   />
    // );
    const netError = <NetError />;

    // if (!hasSignIn && isJPDomain()) {
    //   return shareEmpty;
    // }
    if (loading) {
      return table;
    } else {
      if (window.__online__) {
        // if (shareList.length == 0 && !this.props.searchWord) {
        //   return shareEmpty;
        // } else {
        //   return table;
        // }
        return table;
      } else {
        return netError;
      }
    }
  };

  render() {
    const { selectList, indeterminate, checkAll } = this.state;
    const { isOnline } = store.appStore;
    const { type } = this.props;
    return (
      <div className={`SharedTable ${selectList.length > 0 ? 'select' : ''}`}>
        {this.getContent(isOnline)}
        {selectList.length > 0 && (
          <SharedBulkOperation
            type={type}
            indeterminate={indeterminate}
            checkAll={checkAll}
            selectList={this.getSeletcData()}
            resetSelect={this.resetSelect}
            updateData={this.initNowPage}
            onChangeSetCurrentPage={this.onChangeSetCurrentPage}
            onCheckAllChange={this.onCheckAllChange}
          />
        )}
      </div>
    );
  }
}
export default SharedTable;
